import React, { Component } from 'react';
import { ErrorMessage, Field } from 'formik';

class NumberField extends Component {
  numberFieldValidate = (value) => {
    const { required, validation } = this.props.field;
    const { min, max } = validation;
    let error;
    if (this.props.isConstructorForm) {
      if (min && value && !((min || min === 0) && value >= min)) {
        error = `Must greater than or equals to ${min}`;
      } else if (max && value && !(max && value <= max)) {
        error = `Must be less than or equals to ${max}`;
      }
    } else {
      if (required && !value) {
        error = 'This field is required';
      } else if (min && !((min || min === 0) && value >= min)) {
        error = `Must greater than or equals to ${min}`;
      } else if (max && !(max && value <= max)) {
        error = `Must be less than or equals to ${max}`;
      }
    }
    console.log(error);
    return error;
  };

  render() {
    const { field, isConstructorForm } = this.props;
    return (
      <>
        <Field
          type={'number'}
          name={field.fieldName}
          className="form-control"
          validate={this.numberFieldValidate}
          placeholder={field.placeholder['en']}
          autoComplete="off"
          title={field.fieldTitle['en']}
        />
        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
      </>
    );
  }
}

export default NumberField;
